export default "__VITE_ASSET__C$DJHaHf__"